import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar.component";
import BottomBar from "../common_components/bottom_bar.component";
import { Redirect } from "react-router-dom";
import config from "../../config";
import axios from "axios";
import logo from "../../assets/img/cw_logo.png";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  rootbkg: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "600",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 210,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  errorNotchedOutline: {
    borderWidth: "1px",
    borderColor: "#d00000 !important",
  },
  labelColor: {},
  signin_text: {
    color: "black",
    fontFamily: "Open Sans",
  },
  join_text: {
    color: "#F6277F",
    fontWeight: "600",
    fontFamily: "Open Sans",
    textTransform: "none",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "70%",
    marginLeft: "15%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
  icon: {
    fill: "#F6277F",
  },
  splash_text: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "200",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
});

const btype_arr = [
  {
    value: "Cannabis Brand",
    label: "Cannabis Brand",
  },
  {
    value: "Cannabis Retail ",
    label: "Cannabis Retail ",
  },
  {
    value: "Cannabis Clinic",
    label: "Cannabis Clinic",
  },
  {
    value: "Non-Cannabis Business",
    label: "Non-Cannabis Business",
  },
];

const country_arr = [
  {
    value: "Canada",
    label: "Canada",
  },
];

const license_arr = [
  {
    value: "Retail",
    label: "Retail",
  },
  {
    value: "Production",
    label: "Production",
  },
  {
    value: "Recreational Brand",
    label: "Recreational Brand",
  },
  {
    value: "Medical Brand",
    label: "Medical Brand",
  },
  {
    value: "Other",
    label: "Other",
  },
];

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: "",
      lname: "",
      pnumber: "",
      email: "",
      bname: "",
      btype: "Cannabis Brand",
      lnumber: "",
      ltype: "Retail",
      country: "Canada",
      addline_one: "",
      addline_two: "",
      city: "",
      province: "",
      postal: "",
      website: "",
      comments: "",
      fname_err: false,
      lname_err: false,
      pnumber_err: false,
      email_err: false,
      city_err: false,
      province_err: false,
      postal_err: false,
      thank_screen: false,
      redirect: false,
      isSubmitting: false,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    document.title = "Join | CanaWho";
  }

  submitForm() {
    this.setState({ isSubmitting: true });
    const {
      fname,
      lname,
      pnumber,
      email,
      bname,
      lnumber,
      btype,
      ltype,
      comments,
      addline_one,
      addline_two,
      city,
      province,
      country,
      postal,
      website,
      isSubmitting,
    } = this.state;
    // console.log(btype, ltype);
    var letters = /^[A-Za-z]+$/;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var postalcode = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    if (
      fname &&
      lname &&
      pnumber &&
      email &&
      bname &&
      addline_one &&
      city &&
      province &&
      postal &&
      website
    ) {
      if (!fname.match(letters)) {
        this.setState({ fname_err: true });
      } else if (!lname.match(letters)) {
        this.setState({ lname_err: true });
      } else if (!pnumber.match(phoneno)) {
        this.setState({ pnumber_err: true });
      } else if (!email.match(mailformat)) {
        this.setState({ email_err: true });
      } else if (!city.match(letters)) {
        this.setState({ city_err: true });
      } else if (!province.match(letters)) {
        this.setState({ province_err: true });
      } else if (!postalcode.test(postal)) {
        this.setState({ postal_err: true });
      } else {
        const obj = {
          name: bname.trim(),
          type: btype.trim(),
          license_number: lnumber.trim(),
          license_type: ltype.trim(),
          contact: {
            first_name: fname.trim(),
            last_name: lname.trim(),
            phone_number: pnumber.trim(),
            email: email.toLowerCase(),
          },
          address_line1: addline_one.trim(),
          address_line2: addline_two.trim(),
          city: city.trim(),
          province: province.trim(),
          country: country.trim(),
          postal_code: postal.trim(),
          additional_comments: comments.trim(),
          website: website.trim(),
        };
        axios
          .post(BACKEND_URL + `/brand/addCompanyCommunity`, obj)
          .then((res) => {
            // console.log("Data recieved", res);
            // alert("Application submitted");

            this.setState({ thank_screen: true });
          })
          .catch(function (error) {
            if (error.response) {
              /*
               * The request was made and the server responded with a
               * status code that falls out of the range of 2xx
               */
              // console.log(error.response.data);
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              /*
               * The request was made but no response was received, `error.request`
               * is an instance of XMLHttpRequest in the browser and an instance
               * of http.ClientRequest in Node.js
               */
              // console.log(error.request);
            } else {
              // Something happened in setting up the request and triggered an Error
              // console.log("Error", error.message);
            }
            // console.log(error);
            alert(error.response.data.message);
          });
      }
    } else {
      alert("Please enter the required fields");
    }
  }

  handleRedirect() {
    setTimeout(() => {
      if (this.state.thank_screen) {
        this.setState({ redirect: true });
      }
    }, 5000);
  }

  render() {
    const { classes } = this.props;
    const {
      fname,
      lname,
      pnumber,
      email,
      bname,
      lnumber,
      btype,
      ltype,
      country,
      addline_one,
      addline_two,
      city,
      province,
      postal,
      website,
      comments,
      thank_screen,
      redirect,
      fname_err,
      lname_err,
      pnumber_err,
      email_err,
      city_err,
      province_err,
      postal_err,
      isSubmitting,
    } = this.state;

    if (redirect) {
      return <Redirect to="/login" />;
    }

    if (thank_screen === true) {
      this.handleRedirect();
      return (
        <div className={classes.root}>
          <TopAppBar />
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: "100vh" }}
          >
            <h3 className={classes.splash_text}>
              Thank you for your interest, our team will contact you shortly.
            </h3>
            <h1
              className={classes.text_title}
              style={{ fontWeight: "bold", marginTop: -5 }}
            >
              <u>Express Yourself !</u>
            </h1>
          </Grid>
          <Grid container alignItems="center" justify="center">
            <img
              alt=""
              style={{ padding: 30, height: 60, boxSizing: "unset" }}
              src={logo}
            />
          </Grid>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <TopAppBar />
        <Grid container direction="column" alignItems="center" justify="center">
          <Paper style={{ width: "80%", alignItems: "center", marginTop: 50 }}>
            <div className={classes.paper}>
              <Grid
                style={{ backgroundColor: "#F9F9F9", width: "100%" }}
                container
                alignItems="center"
                justify="center"
              >
                <h1 className={classes.text_title}>
                  <u>Let's Work Together</u>
                </h1>
                <Grid
                  item
                  style={{
                    backgroundColor: "#FFF",
                    width: "85%",
                    padding: 24,
                    marginBottom: 24,
                  }}
                >
                  <Typography variant="h6" className={classes.signin_text}>
                    Welcome to the CanaWho Business Community, here you will
                    begin the process of joining our community by registering
                    your business. Cannabis and Non-Cannabis Brands are welcome,
                    there are tremendous opportunities in our community for
                    everyone.
                    <br />
                    Fill the information below, and our team will get back to
                    you as quickly as possible.
                    <br />
                    <br />
                    We look forward to welcoming you to our community!
                  </Typography>
                </Grid>
              </Grid>
              <form className={classes.form} noValidate>
                <fieldset className={classes.fieldset}>
                  <legend className={classes.legend_text}>
                    Contact Information
                  </legend>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={6}>
                      <TextField
                        error={fname_err}
                        helperText={
                          fname_err ? "Please enter a valid name" : null
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="first_name"
                        label="First Name"
                        //name="first_name"
                        type="text"
                        value={fname}
                        onChange={(text) => {
                          this.setState({
                            fname: text.target.value,
                            fname_err: false,
                          });
                        }}
                        autoComplete="section-name"
                        autoFocus
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !fname
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        error={lname_err}
                        helperText={
                          lname_err ? "Please enter a valid name" : null
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        //name="last_name"
                        label="Last Name"
                        type="text"
                        id="password"
                        autoComplete="current-password"
                        value={lname}
                        onChange={(text) => {
                          this.setState({
                            lname: text.target.value,
                            lname_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !lname
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={6}>
                      <TextField
                        error={pnumber_err}
                        helperText={
                          pnumber_err
                            ? "Please enter a valid phone number"
                            : "Ex. 123 456 7890"
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="phone_number"
                        label="Phone Number"
                        //name="phone_number"
                        type="tel"
                        autoComplete="section-phone-number"
                        value={pnumber}
                        onChange={(text) => {
                          this.setState({
                            pnumber: text.target.value,
                            pnumber_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !pnumber
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        error={email_err}
                        helperText={
                          email_err
                            ? "Please enter a valid email address"
                            : null
                        }
                        style={{ width: "80%", marginBottom: 18 }}
                        variant="outlined"
                        margin="normal"
                        required
                        //name="email"
                        label="Email"
                        type="text"
                        id="email"
                        autoComplete="current-email"
                        value={email}
                        onChange={(text) => {
                          this.setState({
                            email: text.target.value,
                            email_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !email
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </fieldset>
                <fieldset className={classes.fieldset}>
                  <legend className={classes.legend_text}>
                    Business Information
                  </legend>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="usiness_name"
                        label="Business Name"
                        //name="business_name"
                        type="text"
                        autoComplete="section-name"
                        value={bname}
                        onChange={(text) => {
                          this.setState({ bname: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !bname
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        select
                        //name="business_type"
                        label="Business Type"
                        type="text"
                        id="business_type"
                        value={btype}
                        onChange={(text) => {
                          this.setState({ btype: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        SelectProps={{
                          native: true,
                          classes: { icon: classes.icon },
                        }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      >
                        {btype_arr.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        id="license_number"
                        label="License Number"
                        //name="license_number"
                        type="text"
                        autoComplete="section-number"
                        value={lnumber}
                        onChange={(text) => {
                          this.setState({ lnumber: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        select
                        required
                        label="License Type"
                        type="text"
                        id="license_type"
                        autoComplete="section-type"
                        value={ltype}
                        onChange={(text) => {
                          this.setState({ ltype: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        SelectProps={{
                          native: true,
                          classes: { icon: classes.icon },
                        }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      >
                        {license_arr.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        select
                        required
                        label="Country"
                        type="text"
                        id="country"
                        autoComplete="section-country"
                        value={country}
                        onChange={(text) => {
                          this.setState({ country: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        SelectProps={{
                          native: true,
                          classes: { icon: classes.icon },
                        }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      >
                        {country_arr.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "90%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        //name="address_one"
                        label="Adress Line 1"
                        type="text"
                        id="address_one"
                        autoComplete="section-address"
                        value={addline_one}
                        onChange={(text) => {
                          this.setState({ addline_one: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !addline_one
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "90%" }}
                        variant="outlined"
                        margin="normal"
                        //name="address_two"
                        label="Adress Line 2"
                        type="text"
                        id="address_two"
                        autoComplete="section-address"
                        value={addline_two}
                        onChange={(text) => {
                          this.setState({ addline_two: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        error={city_err}
                        helperText={
                          city_err ? "Please enter a valid city" : null
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="city"
                        label="City"
                        //name="city"
                        type="text"
                        autoComplete="section-city"
                        value={city}
                        onChange={(text) => {
                          this.setState({
                            city: text.target.value,
                            city_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !city
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        error={province_err}
                        helperText={
                          province_err ? "Please enter a valid province" : null
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        //name="province"
                        label="Province"
                        type="text"
                        id="province"
                        autoComplete="section-province"
                        value={province}
                        onChange={(text) => {
                          this.setState({
                            province: text.target.value,
                            province_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !province
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        error={postal_err}
                        helperText={
                          postal_err ? "Please enter a valid postal code" : null
                        }
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="postal_code"
                        label="Postal Code"
                        //name="postal_code"
                        type="text"
                        autoComplete="section-postal-code"
                        value={postal}
                        onChange={(text) => {
                          this.setState({
                            postal: text.target.value,
                            postal_err: false,
                          });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !postal
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        style={{ width: "80%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        //name="website"
                        label="Website"
                        type="text"
                        id="website"
                        autoComplete="section-website"
                        value={website}
                        onChange={(text) => {
                          this.setState({ website: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: {
                            notchedOutline:
                              isSubmitting && !website
                                ? classes.errorNotchedOutline
                                : classes.notchedOutline,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 18 }}>
                      <TextField
                        style={{ width: "90%" }}
                        variant="outlined"
                        margin="normal"
                        multiline
                        //name="additional_comments"
                        label="Additional Comments"
                        type="text"
                        id="additional_comments"
                        autoComplete="section-text"
                        value={comments}
                        onChange={(text) => {
                          this.setState({ comments: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      />
                    </Grid>
                  </Grid>
                </fieldset>
                <Button
                  // type="submit"
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: "#F6277F",
                    boxShadow: "2",
                    width: 250,
                  }}
                  className={classes.submit}
                  onClick={this.submitForm}
                >
                  <Typography variant="h6" className={classes.enter_text}>
                    Join Our Company Community
                  </Typography>
                </Button>
              </form>
              <Grid>
                <img
                  alt=""
                  style={{ padding: 10, marginTop: 16, height: 80 }}
                  src={logo}
                />
              </Grid>
            </div>
          </Paper>
        </Grid>
        <BottomBar />
      </div>
    );
  }
}

SignUp.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignUp);
